import React, { useState, useEffect } from 'react';
import { get, set } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { Accordion, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useTranslation } from 'react-i18next';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import BtnAdd from '../../Components/Utility/FilterAction/BtnAdd';
import Loader from '../../Components/Utility/Loader/Loader';
import { isIdValid } from '../../Components/helper';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';

function PortOfLanding({ renderTooltipDelete }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails: { portOfLandingList },
    Users: { logInRights },
  } = reducer;
  const { CheckActionPermission } = useComponent();

  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'category', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(logInRights, 'masters', 'category', 'delete');
  const [state, setState] = useState({
    portOfLanding: [],
    buttonDown: false,
    isLoading: false,
    scrollEl: null,
    errors: null,
    showDeleteModal: false,
    deleteId: null,
    buttonDisabled: false,
  });
  const { portOfLanding, buttonDown, isLoading, scrollEl, errors, deleteId, showDeleteModal, buttonDisabled } = state;

  const handleChange = (value, ind) => {
    const errors = {};
    const cloneLanding = portOfLanding;
    if (value.trim() === '') {
      set(errors, `${ind}`, t('PORT_OF_LANDING.INVALID_ENTRY'));
    }
    cloneLanding[ind].name = value;
    const checkDuplidates = checkDuplicates(cloneLanding, 'name');
    if (Array.isArray(checkDuplidates) && checkDuplidates.length > 0) {
      checkDuplidates.forEach((vl) => {
        set(errors, `${vl}`, t('PORT_OF_LANDING.ENTRY_ALREADY_EXIST'));
      });
    }
    setState((prev) => ({ ...prev, portOfLanding: cloneLanding, errors }));
  };

  useEffect(() => {
    if (Array.isArray(portOfLandingList)) {
      setState((prev) => ({ ...prev, portOfLanding: portOfLandingList }));
    }
  }, [portOfLandingList]);

  const addNewLanding = () => {
    const cloneLanding = portOfLanding;
    cloneLanding.push({ name: '' });
    setState((prev) => ({ ...prev, portOfLanding: cloneLanding }));
  };

  const removeLanding = (id) => {
    const cloneLanding = portOfLanding;
    if (!isIdValid(id)) {
      cloneLanding.splice(id, 1);
      setState((prev) => ({ ...prev, portOfLanding: cloneLanding }));
    } else if (isIdValid(id)) {
      setState((prev) => ({
        ...prev,
        deleteId: null,
        showDeleteModal: false,
      }));
      dispatch(action.deletePortOfLanding(id, t));
    }
  };

  const renderTooltipOpenClose = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {buttonDown ? t('PORT_OF_LANDING.CLOSE') : t('PORT_OF_LANDING.OPEN')}
    </Tooltip>
  );

  const callApi = () => {
    if (!buttonDown && Array.isArray(portOfLandingList) && portOfLandingList.length === 0) {
      dispatch(action.fetchAllPortoflanding());
    }
    setState((prev) => ({ ...prev, buttonDown: !buttonDown }));
  };

  useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 1000;
    }
  }, [scrollEl]);

  const checkValidation = () => {
    let hasError = false;
    const errors = {};
    const cloneLanding = portOfLanding;
    const checkDuplicate = checkDuplicates(portOfLanding, 'name');

    const filteredName = cloneLanding?.filter((vl) => vl?.name.trim() === '');

    if (Array.isArray(filteredName) && filteredName?.length > 0) {
      hasError = true;
      cloneLanding?.forEach((vl, ind) => {
        if (vl?.name.trim() === '') {
          set(errors, `${ind}`, t('PORT_OF_LANDING.THIS_FIELD_REQUIRED'));
        }
      });
    } else if (Array.isArray(checkDuplicate) && checkDuplicate.length > 0) {
      hasError = true;
      if (Array.isArray(checkDuplicate) && checkDuplicate.length > 0) {
        checkDuplicate.forEach((vl) => {
          set(errors, `${vl}`, t('PORT_OF_LANDING.ENTRY_ALREADY_EXIST'));
        });
      }
    }
    setState((prev) => ({ ...prev, errors }));
    return hasError;
  };

  const addPortOfLanding = async () => {
    if (!checkValidation()) {
      setState((prev) => ({
        ...prev,
        buttonDisabled: true,
      }));
      await dispatch(action.addPortOfLandingAction(portOfLanding));
      setState((prev) => ({
        ...prev,
        buttonDisabled: false,
      }));
    }
  };

  const checkDuplicates = (array, key) => {
    const duplicateIndexes = array.reduce((acc, obj, index) => {
      if (!acc[obj[key]]) {
        acc[obj[key]] = [index];
      } else {
        acc[obj[key]].push(index);
      }
      return acc;
    }, {});
    return Object.values(duplicateIndexes)
      .filter((arr) => arr.length > 1)
      .flat();
  };
  return (
    <>
      <Accordion className="mb-4 master-accordian">
        <Card>
          <Card.Header>
            <div className="title-container">
              <p>{t('PORT_OF_LANDING.TITLE')}</p>
            </div>
            <div className={!MasterAddEditAccess ? 'action-title-btns single-btn' : 'action-title-btns'}>
              <BtnAdd onBtnClick={addNewLanding} masterAddEditAccess={MasterAddEditAccess} />
              <OverlayTrigger placement={t('PORT_OF_LANDING.AUTO')} delay={{ show: 250, hide: 400 }} overlay={renderTooltipOpenClose}>
                <button onClick={() => callApi()} type="button">
                  {buttonDown ? <i className="icon-new-up" /> : <i className="icon-new-down" />}
                </button>
              </OverlayTrigger>
            </div>
          </Card.Header>
          {buttonDown && (
            <Card.Body>
              {isLoading ? (
                <Loader />
              ) : (
                <PerfectScrollbar
                  containerRef={(ref) => {
                    setState((prev) => ({ ...prev, scrollEl: ref }));
                  }}
                >
                  <ul>
                    {portOfLanding?.length > 0 &&
                      portOfLanding?.map((vl, ind) => {
                        return (
                          <div className="list-container" key={vl?._id}>
                            <li>
                              <div className="input-container">
                                <div className="d-flex">
                                  <input
                                    type="text"
                                    onChange={(e) => handleChange(e.target.value, ind)}
                                    value={vl?.name}
                                    placeholder={t('PORT_OF_LANDING.ENTER_PORT_OF_LANDING')}
                                  />
                                </div>

                                {get(errors, `${ind}`, '') && <label className="text-danger m-0 p-1">{get(errors, `${ind}`, '')}</label>}
                              </div>
                              <div className="input-action">
                                {MasterDeleteAccess && (
                                  <OverlayTrigger placement={t('PORT_OF_LANDING.AUTO')} delay={{ show: 250, hide: 400 }} overlay={renderTooltipDelete}>
                                    <button
                                      type="button"
                                      aria-label="Delete"
                                      onClick={() => {
                                        if (vl?._id) {
                                          setState((prev) => ({
                                            ...prev,
                                            deleteId: vl?._id,
                                            showDeleteModal: true,
                                          }));
                                        } else {
                                          removeLanding(ind);
                                        }
                                      }}
                                    >
                                      <span className="icon-delete mt-3 f-20" />
                                    </button>
                                  </OverlayTrigger>
                                )}
                              </div>
                            </li>
                          </div>
                        );
                      })}
                  </ul>
                </PerfectScrollbar>
              )}
              {MasterAddEditAccess ? (
                <div className="section-save">
                  <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                    <button aria-label="Save" type="button" disabled={buttonDisabled} className="btn btn-page-filter btn-white" onClick={addPortOfLanding}>
                      <span className="icon-Save c-button-align f-20 mr-2" />
                      {t('PORT_OF_LANDING.SAVE')}
                    </button>
                  </CustomTooltip>
                </div>
              ) : (
                ''
              )}
            </Card.Body>
          )}
        </Card>
      </Accordion>
      {showDeleteModal && (
        <ConfirmationPopup
          onOpen={showDeleteModal}
          onConfirm={() => removeLanding(deleteId)}
          title={t('PORT_OF_LANDING.DELETE_FROM_SYSTEM_MASTER')}
          message={t('PORT_OF_LANDING.CONFIRM_DELETE')}
          toggle={() =>
            setState((prev) => ({
              ...prev,
              deleteId: null,
              showDeleteModal: !prev.showDeleteModal,
            }))
          }
        />
      )}
    </>
  );
}
export default PortOfLanding;
